(function ($) {

    var itemsToShow = 3;
    var currentIndex = 0;

    function showItems() {

        var $items = $('.c-post-item');
        var totalItems = $items.length;

        for (var i = currentIndex; i < currentIndex + itemsToShow; i++) {
            if ($items.eq(i).length) {
                $items.eq(i).fadeIn();
            }
        }

        currentIndex += itemsToShow;

        // Hide the "Show More" button if there are no more items to show
        if (currentIndex >= totalItems) {
            $('#showMore').parent().parent().hide();
        }
    }

    // Show initial items on DOM ready
    showItems();

    // Show more items on button click
    $('#showMore').on('click', function(e) {
        e.preventDefault();
        showItems();
    });

})(jQuery);
